<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import Button from "@components/global/button.vue";
import Input from "@components/global/input.vue";

const STORAGE_KEY = "newsletter-popup";
const DISMISS_COOLDOWN = 24 * 60 * 60 * 1000;
const OPEN_DELAY = 2000;

const open = ref(false);
const processing = ref(false);
const success = ref(false);
const user = ref({});
const errors = ref({});

let openTimeout = null;

onMounted(() => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "subscribed") return;
  if (stored && Date.now() - Number(stored) < DISMISS_COOLDOWN) return;
  openTimeout = setTimeout(() => (open.value = true), OPEN_DELAY);
});

onUnmounted(() => clearTimeout(openTimeout));

function dismiss() {
  if (!success.value) localStorage.setItem(STORAGE_KEY, String(Date.now()));
  open.value = false;
}

function submit(form) {
  form.preventDefault();
  if (!processing.value) {
    processing.value = true;
    axios
      .post("/api/newsletter", user.value)
      .then(() => {
        errors.value = {};
        processing.value = false;
        success.value = true;
        localStorage.setItem(STORAGE_KEY, "subscribed");
        setTimeout(() => (open.value = false), 2000);
      })
      .catch((error) => {
        processing.value = false;
        success.value = false;
        if (error.response.status === 422) errors.value = error.response.data.errors;
      });
  }
}
</script>

<template>
  <Transition name="fade">
    <div
      class="fixed left-0 top-0 isolate z-[1000] flex h-full w-full select-none items-center justify-center p-4"
      v-if="open"
    >
      <div class="fixed left-0 top-0 -z-10 h-full w-full bg-black/75" @click="dismiss" />
      <div
        class="relative z-10 flex w-full max-w-[480px] flex-col items-center gap-6 rounded-2xl bg-bgMain p-10 text-center"
      >
        <Button
          class="btn icon absolute right-[3px] top-[3px]"
          icon="fa-solid fa-xmark"
          @click="dismiss"
        />
        <h2 class="text-[3rem]">Subscribe to our newsletter.</h2>
        <span class="text-sm">Don’t miss anything new planted in our garden.</span>
        <div v-if="success">Thank you for Subscribing</div>
        <form class="relative w-full" @submit="submit" v-else>
          <Input
            placeholder="Insert your email here"
            class="w-fit"
            type="email"
            :required="true"
            v-model="user.email"
            :error="errors.email && errors.email[0]"
          />
          <Button
            type="submit"
            label="Subscribe"
            class="primary absolute bottom-1.5 right-1.5 top-1.5"
            :processing="processing"
          />
        </form>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.btn.icon {
  @apply text-2xl;
}
</style>
